"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true,
})
exports.BicyclingLayer = undefined

var _defineProperty2 = require("babel-runtime/helpers/defineProperty")

var _defineProperty3 = _interopRequireDefault(_defineProperty2)

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of")

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf)

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck")

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2)

var _createClass2 = require("babel-runtime/helpers/createClass")

var _createClass3 = _interopRequireDefault(_createClass2)

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn")

var _possibleConstructorReturn3 = _interopRequireDefault(
  _possibleConstructorReturn2
)

var _inherits2 = require("babel-runtime/helpers/inherits")

var _inherits3 = _interopRequireDefault(_inherits2)

var _react = require("react")

var _react2 = _interopRequireDefault(_react)

var _propTypes = require("prop-types")

var _propTypes2 = _interopRequireDefault(_propTypes)

var _MapChildHelper = require("../utils/MapChildHelper")

var _constants = require("../constants")

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

/**
 * A wrapper around `google.maps.BicyclingLayer`
 *
 * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
 */
/*
 * -----------------------------------------------------------------------------
 * This file is auto-generated from the corresponding file at `src/macros/`.
 * Please **DO NOT** edit this file directly when creating PRs.
 * -----------------------------------------------------------------------------
 */
/* global google */
var BicyclingLayer = (exports.BicyclingLayer = (function(_React$PureComponent) {
  ;(0, _inherits3.default)(BicyclingLayer, _React$PureComponent)

  /*
   * @see https://developers.google.com/maps/documentation/javascript/3.exp/reference#BicyclingLayer
   */
  function BicyclingLayer(props, context) {
    ;(0, _classCallCheck3.default)(this, BicyclingLayer)

    var _this = (0, _possibleConstructorReturn3.default)(
      this,
      (
        BicyclingLayer.__proto__ ||
        (0, _getPrototypeOf2.default)(BicyclingLayer)
      ).call(this, props, context)
    )

    var bicyclingLayer = new google.maps.BicyclingLayer()
    ;(0, _MapChildHelper.construct)(
      BicyclingLayer.propTypes,
      updaterMap,
      _this.props,
      bicyclingLayer
    )
    bicyclingLayer.setMap(_this.context[_constants.MAP])
    _this.state = (0, _defineProperty3.default)(
      {},
      _constants.BICYCLING_LAYER,
      bicyclingLayer
    )
    return _this
  }

  ;(0, _createClass3.default)(BicyclingLayer, [
    {
      key: "componentDidMount",
      value: function componentDidMount() {
        ;(0, _MapChildHelper.componentDidMount)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap
        )
      },
    },
    {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        ;(0, _MapChildHelper.componentDidUpdate)(
          this,
          this.state[_constants.BICYCLING_LAYER],
          eventMap,
          updaterMap,
          prevProps
        )
      },
    },
    {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        ;(0, _MapChildHelper.componentWillUnmount)(this)
        var bicyclingLayer = this.state[_constants.BICYCLING_LAYER]
        if (bicyclingLayer) {
          bicyclingLayer.setMap(null)
        }
      },
    },
    {
      key: "render",
      value: function render() {
        return false
      },
    },
  ])
  return BicyclingLayer
})(_react2.default.PureComponent))

BicyclingLayer.propTypes = {}
BicyclingLayer.contextTypes = (0, _defineProperty3.default)(
  {},
  _constants.MAP,
  _propTypes2.default.object
)
exports.default = BicyclingLayer

var eventMap = {}

var updaterMap = {}



//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/lib/components/BicyclingLayer.js
// module id = 973
// module chunks = 0